import cn from 'classnames'
import PropTypes from 'prop-types'
import ResponsiveImage from './ResponsiveImage'
import { createUseStyles } from '../helpers/createStyles'
import { grid, theme } from '../styles/theme'
import ImageWithHotspots from './ImageWithHotspots'

const ImageBlock = ({
  className,
  block: { images, caption },
  limit = 2,
  hideCaptions
}) => {
  const styles = useStyles()

  return (
    <div className={cn(styles.root, className)}>
      {images && images.slice(0, limit).map((image, _, displayedImages) => {
        if (image._type === 'imageWithHotspot') {
          return (
            <ImageWithHotspots
              image={image.image}
              hotspots={image.hotspots}
              key={image._key}
              className={cn({
                [styles.single]: displayedImages.length === 1
              })}
            />
          )
        }
        return (
          <div key={image._key} className={cn('image-block-wrapper', styles.imageWrapper, { [styles.single]: displayedImages.length === 1 })}>
            <ResponsiveImage image={image} className={styles.image} background='transparent' />
          </div>
        )
      })}
      {caption && !hideCaptions && (
        <span className={cn(styles.caption, 'is-caption')}>{caption}</span>
      )}
    </div>
  )
}

const useStyles = createUseStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: grid.sm.gutter,
    [theme.breakpoints.up('md')]: {
      gap: grid.md.gutter
    }
  },
  imageWrapper: {
    width: '100%',
    overflow: 'hidden',
    zIndex: 4
  },
  image: {},
  single: {
    gridColumn: '1 / -1'
  },
  caption: {
    gridColumn: '1 / -1'
  }
})

export const imageBlockProps = {
  caption: PropTypes.string,
  images: PropTypes.array.isRequired
}

ImageBlock.propTypes = {
  className: PropTypes.string,
  block: PropTypes.shape(imageBlockProps).isRequired,
  limit: PropTypes.number,
  hideCaptions: PropTypes.bool
}

export default ImageBlock
